import { useMemo } from 'react';

import { IconSvg, Text, Tooltip } from '@/lib/v2/components';
import { TooltipProps } from '@/lib/v2/components/Tooltip/Tooltip';
import { InfoIcon } from '@/lib/v2/icons/outline';
import { Card } from '@/lib/v3/components';

export interface IActivityUserCard {
  id: string;
  value: number;
}

export interface ICardActivityProps {
  data: IActivityUserCard | null;
  id: string;
  tooltip?: {
    alignment: TooltipProps['alignment'];
  };
  wordings: {
    title: string;
    description: string;
    tooltip: string;
    subtitle: string;
    advance: string;
  };
}

const CardActivity = ({ data, id, wordings, tooltip }: ICardActivityProps) => {
  const { title, description, tooltip: tooltipText, subtitle, advance } = wordings;
  const { value } = data ?? {};
  const haveData = useMemo(() => !!data, [data]);
  return (
    <Card id={id} isAutoHeight={true}>
      <Card.Header>
        <div className="flex w-full flex-row items-center justify-between gap-2">
          <div className="flex flex-row items-center gap-2">
            <Text
              className="uppercase"
              color={haveData ? 'black' : 'gray'}
              fontWeight="semibold"
              variant="sub-headline-2"
            >
              {title}
            </Text>
            <Text color={haveData ? 'black' : 'gray'} fontWeight="normal" variant="text">
              ({subtitle})
            </Text>
          </div>
          <Tooltip
            isDark
            alignment={tooltip?.alignment}
            className={haveData ? '' : 'opacity-40'}
            content={
              haveData && (
                <Text className="flex w-40" color="white" variant="text-sm">
                  {tooltipText}
                </Text>
              )
            }
            position="top"
          >
            <IconSvg height="32" svgComponent={<InfoIcon height={32} width={32} />} width="32" />
          </Tooltip>
        </div>
      </Card.Header>
      <Card.Content>
        <div className="flex w-full flex-row items-center gap-4">
          {typeof value === 'number' && (
            <Text
              className="w-2/6 text-nowrap leading-9"
              color="black"
              fontWeight="medium"
              variant="title-3"
            >
              {`${value}%`}
            </Text>
          )}
          <Text className={'w-5/6'} color="black" fontWeight="normal" variant="text">
            {haveData ? description : advance}
          </Text>
        </div>
      </Card.Content>
    </Card>
  );
};

export default CardActivity;
